import {
    ADD_TO_ORDER,
    REMOVE_FROM_ORDER,
    UPDATE_ORDER_ITEM,
    CLEAR_ORDER,
  } from "../actions/order";
  
  const getSavedOrder = () => {
    try {
      const saved = localStorage.getItem("yaman-order");
  
      return saved
        ? JSON.parse(saved)
        : [];
    } catch {
      return [];
    }
  };
  
  const saveOrder = (items) => {
    try {
      localStorage.setItem(
        "yaman-order",
        JSON.stringify(items)
      );
    } catch (error) {
      console.log(error);
    }
  };
  
  const initialState = {
    items: getSavedOrder(),
  };
  
  const OrderReducer = (
    state = initialState,
    action
  ) => {
    switch (action.type) {
      case ADD_TO_ORDER: {
        const newItem = action.payload;
  
        /*
         * إذا كانت نفس الوجبة ونفس الملاحظات
         * نزيد الكمية بدل إضافة سطر جديد.
         */
        const existingIndex =
          state.items.findIndex(
            (item) =>
              item.mealId ===
                newItem.mealId &&
              item.notes ===
                newItem.notes
          );
  
        let newItems;
  
        if (existingIndex !== -1) {
          newItems = state.items.map(
            (item, index) =>
              index === existingIndex
                ? {
                    ...item,
                    quantity:
                      item.quantity +
                      newItem.quantity,
                  }
                : item
          );
        } else {
          newItems = [
            ...state.items,
            newItem,
          ];
        }
  
        saveOrder(newItems);
  
        return {
          ...state,
          items: newItems,
        };
      }
  
      case UPDATE_ORDER_ITEM: {
        const newItems =
          state.items.map((item) =>
            item.lineId ===
            action.payload.lineId
              ? {
                  ...item,
                  ...action.payload.data,
                }
              : item
          );
  
        saveOrder(newItems);
  
        return {
          ...state,
          items: newItems,
        };
      }
  
      case REMOVE_FROM_ORDER: {
        const newItems =
          state.items.filter(
            (item) =>
              item.lineId !==
              action.payload
          );
  
        saveOrder(newItems);
  
        return {
          ...state,
          items: newItems,
        };
      }
  
      case CLEAR_ORDER:
        saveOrder([]);
  
        return {
          ...state,
          items: [],
        };
  
      default:
        return state;
    }
  };
  
  export default OrderReducer;